import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
export const GET_FOLDER = registerQuery({
  fieldName: 'getFolder',
  args: ['folderId'],
  fetcher: ({
    folderId
  }) => http.get(`/inbounddb-objects/v1/crm-objects/FOLDER/${folderId || 0}`, {
    query: {
      properties: 'hs_folder_origin_id'
    }
  })
});